/**
 * Cyber-Minimal Modal Component
 * 
 * @param {Object} props
 * @param {string} props.title - Modal title
 * @param {HTMLElement | string} props.content - Modal content
 * @param {HTMLElement | string} props.footer - Optional footer content
 * @param {Function} props.onClose - Close handler
 */
export function createModal({ title, content, footer, onClose }) {
  const overlay = document.createElement('div');
  overlay.className = 'cm-modal-overlay';
  
  const modal = document.createElement('div');
  modal.className = 'cm-modal';
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.setAttribute('aria-labelledby', 'cm-modal-title');
  
  const header = document.createElement('div');
  header.className = 'cm-modal__header';
  
  const titleEl = document.createElement('h2');
  titleEl.id = 'cm-modal-title';
  titleEl.className = 'cm-modal__title';
  titleEl.textContent = title;
  
  const closeBtn = document.createElement('button');
  closeBtn.className = 'cm-modal__close';
  closeBtn.innerHTML = '&times;';
  closeBtn.setAttribute('aria-label', 'Close modal');
  
  const close = () => {
    overlay.classList.remove('cm-modal-overlay--active');
    setTimeout(() => {
      overlay.remove();
      if (onClose) onClose();
    }, 300);
  };
  
  closeBtn.onclick = close;
  overlay.onclick = (e) => { if (e.target === overlay) close(); };
  
  header.appendChild(titleEl);
  header.appendChild(closeBtn);
  modal.appendChild(header);
  
  const body = document.createElement('div');
  body.className = 'cm-modal__body';
  
  if (typeof content === 'string') {
    body.innerHTML = content;
  } else if (content instanceof HTMLElement) {
    body.appendChild(content);
  }
  
  modal.appendChild(body);
  
  if (footer) {
    const footerEl = document.createElement('div');
    footerEl.className = 'cm-modal__footer';
    if (typeof footer === 'string') {
      footerEl.innerHTML = footer;
    } else if (footer instanceof HTMLElement) {
      footerEl.appendChild(footer);
    }
    modal.appendChild(footerEl);
  }
  
  overlay.appendChild(modal);
  
  // Method to open the modal
  overlay.open = () => {
    document.body.appendChild(overlay);
    requestAnimationFrame(() => {
      overlay.classList.add('cm-modal-overlay--active');
    });
  };
  
  return overlay;
}
